module.exports = __webpack_public_path__ + "static/media/info.41a642ba.mp3";